/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data:{
        locked:false,
        voteLocked:false,
        parentId:0,
        commentContainerID:0, //容器id
        showEmoji:false,
        //分页数据
        selector:".comment-list",
        api:"getCommentList",
        param:{
            post_id:qk_global.post_id,
            orderby:'desc',
            author:false
        }
    },
    async mounted(){
        
    },
    methods:{
        submit(){ 
            if(!qktoken) return this.$createModal('login');
            if(this.locked == true) return;
            
            this.locked = true
            
            let param = {
                'comment_post_ID':qk_global.post_id,
                'comment':this.$refs.textarea.value,
                'comment_parent':this.parentId,
            }

            this.$http.post(qk_rest_url+'sendComment',param).then(res => {
                if(this.parentId){
                    let children = this.$el.querySelector('#comment-'+this.commentContainerID + ' .children')
                    if(children) {
                        children.insertAdjacentHTML('beforeend', res.data)
                    }else{
                        this.$el.querySelector('#comment-'+this.commentContainerID + ' #respond').insertAdjacentHTML('beforebegin','<ul class="children">' + res.data + '</ul>')
                    }
                }else{
                    this.$refs.commentList.insertAdjacentHTML('afterbegin', res.data)
                }
                
                this.$refs.textarea.value = ''
                this.locked = false
                
                if(this.$refs.commentEmpty){
                    this.$refs.commentEmpty.remove()
                }
                

            }).catch(err => {
                this.locked = false
                this.$message({ message: qkGetApiError(err, '操作失败') , type: 'error' });
            })
        },
        resetting() {
            this.parentId = 0;
            this.commentContainerID = 0;
            
            //Object.assign(this.$data, this.$options.data.bind(this)())
            
            this.$el.insertAdjacentElement("afterbegin",this.$refs.respond)
            this.$refs.textarea.placeholder ="只是一直在等你而已，才不是想被评论呢～";
        },
        reply(comment_id,parent_id){
            
            if(this.parentId == comment_id) {
                return this.resetting()
            }
            //被回复的id
            this.parentId = comment_id;
            this.commentContainerID = parent_id;
            
            document.querySelector('#comment-'+parent_id).appendChild(this.$refs.respond)
            
            var name = event.target.parentNode.parentNode.parentNode.querySelector('.user-name').textContent//event.path[4].querySelector('.user-name').innerText;
            
            this.$refs.textarea.placeholder ="回复 @"+ name +" :";
            this.$refs.textarea.focus()
        },
        vote(type,comment_id,e) {
            if(!qktoken) return this.$createModal('login');
            
            if(this.voteLocked == true) return;
            this.voteLocked = true;
            
            //let e = event;
            this.$http.post(qk_rest_url+'commentVote','type='+type+'&comment_id='+comment_id).then(res=>{
                //let parent = e.target.parentNode;
                if(e.classList.contains('voted')){
                    e.classList.remove("voted");
                }else{
                    e.classList.add("voted");
                    
                }
                
                this.voteLocked = false;
                
                e.querySelector('span').innerText = ' ' + res.data.like
                // e.target.innerHtml = ' ' + res.data.like
            }).catch(err => {
                this.voteLocked = false;
                this.$message({ message: qkGetApiError(err, '操作失败') , type: 'error' });
            })
        },
        changeOrder(order){
            if(this.param.orderby == order) return;
            this.resetting();
            this.param.orderby = order;
            this.$refs.commentPageNav.load(1,'',true)
        },
        tabClick(bool) {
            if(this.param.author == bool) return;
            this.resetting();
            this.param.author = bool;
            this.$refs.commentPageNav.load(1,'',true);
        },
        handleClick(emoji) {
            this.$refs.textarea.value +="["+ emoji.name +"]";
            this.$refs.textarea.focus()
        }
    }
};
